import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * Only allows safe HTML tags for formatting
 */
export const sanitizeHtml = (dirty: string): string => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true
  });
};

/**
 * Sanitizes plain text by removing HTML tags and limiting length
 * Use for user inputs that should not contain any HTML
 */
export const sanitizeText = (text: string, maxLength: number = 1000): string => {
  return text
    .trim()
    .replace(/[<>]/g, '') // Remove potential HTML tags
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .substring(0, maxLength);
};

/**
 * Sanitizes email addresses
 */
export const sanitizeEmail = (email: string): string => {
  return email.toLowerCase().trim().substring(0, 255);
};

/**
 * Sanitizes user profile data
 */
export const sanitizeProfileData = (data: {
  name?: string;
  bio?: string;
  [key: string]: any;
}) => {
  return {
    ...data,
    name: data.name ? sanitizeText(data.name, 100) : data.name,
    bio: data.bio ? sanitizeText(data.bio, 500) : data.bio
  };
};

/**
 * Sanitizes review content
 */
export const sanitizeReviewContent = (content: string): string => {
  // Allow some basic formatting but sanitize HTML
  return sanitizeHtml(content).substring(0, 5000);
};
